import axios from "axios";

const BASE_URL = "https://api.mshelhomes.com/api/mshel-club";

// Create axios instance with default headers
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

export default {
  /**
   * Fetch training types for MMC
   * @returns {Promise} Axios promise containing the responses
   */
  getTrainingTypeMmc() {
    return apiClient.get("/get-training-types/mmc");
  },

  /**
   * Fetch training types for REM
   * @returns {Promise} Axios promise containing the response
   */
  getTrainingTypeMrem() {
    return apiClient.get("/get-training-types/rem");
  },

  /**
   * Fetch the list of business sectors
   * @returns {Promise} Axios promise containing the response
   */
  getBusinessSector() {
    return apiClient.get("/business-sectors");
  },

  createRegistration(formData) {
    return axios.post(`${BASE_URL}/new-registration`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60000, // 60 seconds for large file uploads
    });
  },
};